import { logger } from '@/utils/logger';

/**
 * What a saga may tell the user without a component in between (#743): an
 * error toast, shown whatever page is on screen. Injected into the sagas'
 * context like a gateway, so a test passes a fake one.
 */
export interface Notifier {
  error(message: string): void;
}

/**
 * The app's notifier. The store is built before React mounts, so it starts
 * unplugged and forwards to the snackbar once `NotifierBridge` connects it;
 * a message sent before that (or after the bridge unmounts) is only logged.
 */
export function createBridgedNotifier() {
  let target: Notifier | null = null;
  const notifier: Notifier = {
    error: (message) => {
      if (target) target.error(message);
      else logger.warn('[notifier] No UI connected; dropped error toast:', message);
    },
  };
  /** Plug the UI in; the returned function unplugs it (only if still the one plugged). */
  const connect = (next: Notifier): (() => void) => {
    target = next;
    return () => {
      if (target === next) target = null;
    };
  };
  return { notifier, connect };
}

export const appNotifier = createBridgedNotifier();
